import { Translate, useTranslate } from '~/i18n';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import { ArrowUpLeft, ArrowUpRight } from '~/svgs/navbar';
import { isJarir } from '~/utils/theme';
import cn from 'classnames';
import { useState } from 'react';
import { useRouter } from 'next/router';
import OfflineExperienceModal from './offline-experience';
import HyproBanner from '../home-page/hypro-banner';
import Container from '../common/container';
import { NewPhoneIcon } from '~/svgs/contact';
import {
   expDetailsBookOnlineBtnEvent,
   expDetailsCallHYSupportBtnEvent,
   expDetailsCallToBookBtnEvent,
   expDetailsMessageSupportBtnEvent,
   expDetailsSellYourExpBtnEvent,
   offlineExperienceNotifyMeBtnEvent,
} from '~/utils/mixpanel-events/experience-details';
import { formatNumber } from '~/utils/format-price';
interface SectionHeaderProps {
   text: React.ReactNode;
}
const SectionHeader = ({ text }: SectionHeaderProps) => {
   return <span className="block mt-1 mb-4 text-2xl font-bold leading-none">{text}</span>;
};

interface BookingDetailsCTAProps {
   price: number;
   discounted_price?: number;
   is_external?: boolean;
   venue_type: string;
   external_link?: string;
   is_dmc?: boolean;
   share_description?: string;
   share_title?: string;
   book_online?: boolean;
   id: string;
   gender: string[];
   venue_type_details?: any;
   refund_policy?: any;
   name?: string;
   city?: string;
   category_title?: string;
   organizer?: string;
}

const getDiscount = (price: number, discounted_price: number) => {
   if (price > 0) {
      const amount = (1 - discounted_price / price) * 100;
      return amount.toFixed() + '';
   }
   return '';
};

export const BookingDetailsCTA = ({
   price,
   discounted_price,
   venue_type,
   is_external,
   external_link,
   is_dmc,
   //    share_description,
   // share_title,
   book_online,
   // gender,
   id,
   venue_type_details,
   refund_policy,
   name,
   city,
   category_title,
   organizer,
}: BookingDetailsCTAProps) => {
   const { dir } = useTranslate();
   const [offlineModal, setOfflineModal] = useState(false);
   const router = useRouter();
   const IS_OFFLINE_VENUE = venue_type === 'offline_experience';

   const getBookingType = () => {
      const bookingTypeData: any = {
         internal: {
            image: '/icons/experiences/thunder.svg',
            bgColor: 'rgba(255, 193, 7, 0.25)',
            iconBgcolor: 'rgba(255, 193, 7)',
         },
         external: {
            image: '/icons/experiences/external.svg',
            bgColor: 'rgba(227, 254, 254, 0.25)',
            iconBgcolor: 'rgba(227, 254, 254)',
         },
         '24_hours_confirmation': {
            image: '/icons/experiences/24-hours.svg',
            bgColor: 'rgba(102, 16, 242, 0.25)',
            iconBgcolor: 'rgba(102, 16, 242)',
         },
         online_experience: {
            bgColor: 'rgba(253, 126, 20, 0.25)',
            iconBgcolor: 'rgba(253, 126, 20)',
         },
         offline_experience: {
            image: '/icons/experiences/offline.svg',
            bgColor: 'rgba(0, 185, 216, 0.25)',
            iconBgcolor: 'rgba(0, 185, 216)',
         },
      };

      if (!venue_type || !bookingTypeData[venue_type]) return null;
      return (
         <div className="absolute bottom-0 flex w-full px-2 bg-gray-100 rounded-b-lg">
            <div className="flex items-center py-2 mx-auto">
               <div
                  className={cn(
                     'flex justify-center w-6 h-6 rounded-md ltr:mr-3 rtl:ml-3',
                     IS_OFFLINE_VENUE ? 'w-8' : ''
                  )}
                  style={{
                     backgroundColor: bookingTypeData[venue_type]?.iconBgcolor,
                  }}>
                  {bookingTypeData[venue_type]?.image ? (
                     <img
                        width="16px"
                        alt="venue type icon"
                        src={bookingTypeData[venue_type]?.image}
                     />
                  ) : null}
               </div>
               <div className="">
                  {/* <div className="flex items-center">
                     <h2 className="text-base font-semibold">{venue_type_details?.long_title}</h2>
                  </div> */}
                  <p className="mt-1 text-sm text-gray-700">
                     {isJarir
                        ? venue_type_details?.description_jarir
                        : venue_type_details?.description}
                  </p>
               </div>
            </div>
         </div>
      );
   };

   // const ideal_for = () => {
   //    if (gender?.length >= 2) return translate({ id: 'common:ideal both' });
   //    const g = gender?.[0];
   //    if (g && g === 'Men') {
   //       return translate({ id: 'common:ideal men' });
   //    } else if (g && g === 'Women') {
   //       return translate({ id: 'common:ideal women' });
   //    } else return translate({ id: 'common:ideal both' });
   // };

   const bookHandler = () => {
      // const isOnline = router.query.category === 'online';

      if (IS_OFFLINE_VENUE) {
         setOfflineModal(true);
         offlineExperienceNotifyMeBtnEvent({
            experienceId: id,
            experienceName: name,
            experienceCity: city,
            experienceCategory: category_title,
            providerName: organizer,
         });
         return;
      }
      expDetailsBookOnlineBtnEvent({
         experienceId: id,
         experienceName: name,
         experienceCity: city,
         experienceCategory: category_title,
         providerName: organizer,
      });
      if (is_external && external_link) return window.open(external_link, '_blank');
      else {
         const { query } = router;

         const { lang, city, category, slug } = query;
         is_dmc
            ? router.push(`/${lang}/sta/packages/${id}/book`)
            : router.push(`/${lang}/experiences/${city}/${category}/${slug}/book`);
      }
   };

   const getButton = () => (
      <button
         id="see-dates"
         onClick={bookHandler}
         className={cn(
            'text-white hover:opacity-75 border  shadow rounded-default !px-8 transition duration-150 ease-in-out focus:outline-none focus:ring-1 ring-offset-1 py-2.5 w-full',
            isJarir
               ? ' bg-jarir-primary border-red-600 focus:ring-jarir-primary'
               : 'bg-primary-green border-primary-green focus:ring-primary-green',
            !book_online && 'bg-opacity-75 border-opacity-75 hover:opacity-100 cursor-not-allowed'
         )}
         disabled={!book_online}>
         <div className="flex items-center justify-center pointer-events-none">
            {book_online ? (
               <div className="font-bold pointer-events-none">
                  {isJarir && !IS_OFFLINE_VENUE ? (
                     <Translate id="jarir:check availability" />
                  ) : IS_OFFLINE_VENUE ? (
                     <Translate id="booking:notify me" />
                  ) : (
                     <Translate id="booking:book online" />
                  )}
               </div>
            ) : (
               <Translate id="booking:book unavailable" />
            )}
            {is_external && (
               <div className="pointer-events-none">
                  {dir === 'ltr' ? (
                     <ArrowUpRight className="ml-4 transform scale-150" />
                  ) : (
                     <ArrowUpLeft className="mr-4 transform scale-150" />
                  )}
               </div>
            )}
         </div>
      </button>
   );

   return (
      <div className="top-0 w-full lg:w-[560px] lg:sticky lg:ltr:pl-0 lg:rtl:pr-0 relative">
         {IS_OFFLINE_VENUE && (
            <OfflineExperienceModal
               venue_id={id}
               name={name}
               category={category_title}
               city={city}
               organizer={organizer}
               open={offlineModal}
               onClose={() => setOfflineModal(false)}
            />
         )}

         <div
            className="fixed inset-x-0 bottom-0 py-2 bg-white md:hidden z-60"
            style={{ boxShadow: '0 -1px 7px 0 rgba(33,37,41,0.2)' }}>
            <Container>
               <div
                  className={cn(
                     'flex items-center',
                     IS_OFFLINE_VENUE ? 'flex-row-reverse' : 'justify-between'
                  )}>
                  {!IS_OFFLINE_VENUE && (
                     <div>
                        {discounted_price || price ? (
                           <div>
                              <div className="font-medium text-gray-600">
                                 <Translate id="common:starts from" />
                              </div>
                              <span className="text-lg font-bold">
                                 <Translate
                                    parseHTML
                                    id="common:price"
                                    values={{ amount: formatNumber(discounted_price || price) }}
                                 />
                              </span>

                              <div>
                                 {discounted_price && discounted_price < price ? (
                                    <span>
                                       <span className="text-gray-500 line-through">
                                          <span className="hidden">
                                             <Translate id="common:price before discount" />
                                          </span>
                                          <Translate
                                             parseHTML
                                             id="common:price"
                                             values={{ amount: formatNumber(price) }}
                                          />
                                       </span>
                                       <span className="text-sm py-0.5 px-1 rounded text-primary-green bg-green-100 last:mr-0 ltr:ml-2 rtl:mr-2">
                                          <span className="hidden">
                                             <Translate id="common:discount percentage" />
                                          </span>
                                          <Translate
                                             id="common:discount"
                                             values={{
                                                amount: `${getDiscount(price, discounted_price)}`,
                                             }}
                                          />
                                       </span>
                                    </span>
                                 ) : null}
                              </div>
                           </div>
                        ) : (
                           <span className="text-lg font-bold">
                              <Translate id="common:free" />
                           </span>
                        )}
                     </div>
                  )}
                  <div className="flex flex-col">
                     <div>{getButton()}</div>
                     {!IS_OFFLINE_VENUE && (
                        <div className="pt-2 text-center">
                           <a
                              id="call-to-book"
                              href="tel:+9668001111805"
                              className="inline-flex items-center font-bold !text-[#0552bc] underline">
                              <NewPhoneIcon className="ltr:mr-1 rtl:ml-1 !text-[#0552bc]" />
                              <Translate id="booking:or call to book" />
                           </a>
                        </div>
                     )}
                  </div>
               </div>
            </Container>
         </div>
         <div
            style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.08)' }}
            className="sticky z-40 hidden py-4 mt-24 mb-12 bg-white border top-24 rounded-default md:block border-opacity-40">
            {!IS_OFFLINE_VENUE && (
               <div className="px-4 pb-4 mb-4 border-b border-opacity-70">
                  {discounted_price || price ? (
                     <div>
                        <div className="font-medium text-gray-600">
                           <Translate id="common:starts from" />
                        </div>
                        <div>
                           <span className="text-xl font-bold">
                              <Translate
                                 parseHTML
                                 id="common:price"
                                 values={{ amount: formatNumber(discounted_price || price) }}
                              />
                           </span>
                           {discounted_price && discounted_price < price ? (
                              <span>
                                 <br />
                                 <span className="text-gray-500 line-through">
                                    <span className="hidden">
                                       <Translate id="common:price before discount" />
                                    </span>
                                    <Translate
                                       parseHTML
                                       id="common:price"
                                       values={{ amount: formatNumber(price) }}
                                    />
                                 </span>
                                 <span className="text-sm py-0.5 px-1 rounded text-primary-green bg-green-100 last:mr-0 ltr:ml-2 rtl:mr-2">
                                    <span className="hidden">
                                       <Translate id="common:discount percentage" />
                                    </span>
                                    <Translate
                                       id="common:discount"
                                       values={{
                                          amount: `${getDiscount(price, discounted_price)}`,
                                       }}
                                    />
                                 </span>
                              </span>
                           ) : null}
                        </div>
                     </div>
                  ) : (
                     <span className="text-lg font-bold">
                        <Translate id="common:free" />
                     </span>
                  )}
               </div>
            )}

            <div className="px-4 mb-10">
               {/* <div className="flex flex-wrap items-center mb-4">
                  <div className="w-6">
                     <PeopleIcon />
                  </div>
                  <div className="text-sm font-medium text-primary-focus">{ideal_for()}</div>
               </div> */}
               <div className="py-4">{getButton()}</div>

               {!IS_OFFLINE_VENUE && refund_policy !== 'Other' && refund_policy !== 'أخرى' && (
                  <div className="relative flex items-center pb-4">
                     <div className="flex-grow border-t"></div>
                     {refund_policy &&
                     refund_policy !== 'Refund is not allowed' &&
                     refund_policy !== 'الاسترداد غير مسموح به' ? (
                        <span className="flex-shrink mx-4 text-sm text-gray-400">
                           <Translate id="booking:cancellation within" />{' '}
                           <span className="lowercase">{refund_policy}</span>
                        </span>
                     ) : (
                        <span className="flex-shrink mx-4 text-sm text-gray-400">
                           <Translate id="booking:no refund policy" />{' '}
                        </span>
                     )}
                     <div className="flex-grow border-t"></div>
                  </div>
               )}

               {!IS_OFFLINE_VENUE && (
                  <div className="text-center">
                     <a
                        id="call-to-book"
                        href="tel:+9668001111805"
                        onClick={() =>
                           expDetailsCallToBookBtnEvent({
                              experienceId: id,
                              experienceName: name,
                              providerName: organizer,
                           })
                        }
                        className="inline-flex items-center font-bold !text-[#0552bc] underline">
                        <NewPhoneIcon className="ltr:mr-1 rtl:ml-1 !text-[#0552bc]" />
                        <Translate id="booking:or call to book" />
                     </a>
                  </div>
               )}
            </div>
            {getBookingType()}
         </div>
         <Container>
            <SectionHeader text={<Translate id="common:need help" />} />
            {isJarir ? (
               <a
                  className="flex p-3 mt-4 border rounded-xl border-gray-50 hover:bg-gray-50"
                  href="tel:920000089"
                  onClick={() =>
                     expDetailsCallHYSupportBtnEvent({
                        experienceId: id,
                        experienceName: name,
                        providerName: organizer,
                     })
                  }>
                  <div className="flex-grow">
                     <span className="flex items-center">
                        <img
                           width="24px"
                           height="24px"
                           src="/images/common/call.svg"
                           alt="call Jarir Tickets"
                           className="ltr:mr-2 rtl:ml-2"
                        />
                        <Translate id="common:call jarir tickets support" />
                     </span>
                  </div>
                  {dir === 'ltr' ? <AngelRightIcon /> : <AngelLeftIcon />}
               </a>
            ) : (
               <>
                  <a
                     target="_blank"
                     rel="noreferrer noopener"
                     href="https://wa.me/966115207040/?text="
                     className="flex p-3 border rounded-xl border-gray-50 hover:bg-gray-50"
                     onClick={() =>
                        expDetailsMessageSupportBtnEvent({
                           experienceId: id,
                           experienceName: name,
                           providerName: organizer,
                        })
                     }>
                     <div className="flex-grow">
                        <span className="flex items-center">
                           <img
                              width="24px"
                              height="24px"
                              src="/images/common/whatsapp.png"
                              alt="halayalla whatsapp"
                              className="ltr:mr-2 rtl:ml-2"
                           />
                           <Translate id="common:message halayalla support" />
                        </span>
                     </div>
                     {dir === 'ltr' ? <AngelRightIcon /> : <AngelLeftIcon />}
                  </a>

                  <a
                     className="flex p-3 mt-4 border rounded-xl border-gray-50 hover:bg-gray-50"
                     href="tel:8001111805"
                     onClick={() =>
                        expDetailsCallHYSupportBtnEvent({
                           experienceId: id,
                           experienceName: name,
                           providerName: organizer,
                        })
                     }>
                     <div className="flex-grow">
                        <span className="flex items-center">
                           <img
                              width="24px"
                              height="24px"
                              src="/images/common/call.svg"
                              alt="call halayalla"
                              className="ltr:mr-2 rtl:ml-2"
                           />
                           <Translate id="common:call halayalla support" />
                        </span>
                     </div>
                     {dir === 'ltr' ? <AngelRightIcon /> : <AngelLeftIcon />}
                  </a>

                  <div className="px-4 pt-10">
                     <HyproBanner
                        small={true}
                        trackEvent={() =>
                           expDetailsSellYourExpBtnEvent({
                              experienceId: id,
                              experienceName: name,
                              providerName: organizer,
                           })
                        }
                     />
                  </div>
               </>
            )}
         </Container>
      </div>
   );
};
